// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Astrolog_container__OxVv\\+ {
  padding: 24px 16px 90px 16px;
  max-width: 390px;
  color: white;
  min-height: 100vh;
  margin: 0 auto;
}

.Astrolog_illustration__a8mup {
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.02);
  width: 100%;
  max-width: 390px;
  aspect-ratio: 1/1;
  margin: 0 auto 24px auto;
  display: block;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.Astrolog_questionText__aQa27 {
  font-size: 15px;
  color: #f0f0f0;
  line-height: 1.65;
  background: rgba(255, 255, 255, 0.05);
  padding: 16px;
  border-radius: 14px;
  backdrop-filter: blur(4px);
  white-space: pre-line;
  text-align: left;
  margin: 22px 0;
}

.Astrolog_questionBlock__ZCT2V {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.Astrolog_questionExamples__KQPP6 {
  color: #b5a8d6;
  opacity: 0.75;
  margin-top: 14px;
  font-size: 15px;
  line-height: 1.5;
}

.Astrolog_questionExamples__KQPP6 ul {
  margin: 7px 0 0 14px;
  padding: 0;
  list-style: disc;
}

.Astrolog_questionExamples__KQPP6 li {
  margin-bottom: 2px;
}

.Astrolog_buttonWrapper__TYJxN {
  width: 240px;
  margin: 0 auto;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Astrolog/Astrolog.module.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB","sourcesContent":[".container {\n  padding: 24px 16px 90px 16px;\n  max-width: 390px;\n  color: white;\n  min-height: 100vh;\n  margin: 0 auto;\n}\n\n.illustration {\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.02);\n  width: 100%;\n  max-width: 390px;\n  aspect-ratio: 1/1;\n  margin: 0 auto 24px auto;\n  display: block;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n}\n\n.questionText {\n  font-size: 15px;\n  color: #f0f0f0;\n  line-height: 1.65;\n  background: rgba(255, 255, 255, 0.05);\n  padding: 16px;\n  border-radius: 14px;\n  backdrop-filter: blur(4px);\n  white-space: pre-line;\n  text-align: left;\n  margin: 22px 0;\n}\n\n.questionBlock {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.questionExamples {\n  color: #b5a8d6;\n  opacity: 0.75;\n  margin-top: 14px;\n  font-size: 15px;\n  line-height: 1.5;\n}\n\n.questionExamples ul {\n  margin: 7px 0 0 14px;\n  padding: 0;\n  list-style: disc;\n}\n\n.questionExamples li {\n  margin-bottom: 2px;\n}\n\n.buttonWrapper {\n  width: 240px;\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Astrolog_container__OxVv+`,
	"illustration": `Astrolog_illustration__a8mup`,
	"questionText": `Astrolog_questionText__aQa27`,
	"questionBlock": `Astrolog_questionBlock__ZCT2V`,
	"questionExamples": `Astrolog_questionExamples__KQPP6`,
	"buttonWrapper": `Astrolog_buttonWrapper__TYJxN`
};
export default ___CSS_LOADER_EXPORT___;
